<template>
    <v-stepper non-linear v-model="step" class="p-0 transparent" id="stepper">
        <v-stepper-header>

            <v-stepper-step :color="step > 1 ? 'green' : color" :complete="step > 1" step="1">
                Registro
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :color="step > 2 ? 'green' : color" :complete="step > 2" step="2">
                Activar cuenta
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :color="step > 2 ? 'green' : color" :complete="step > 3" step="3">
                Finalizar
            </v-stepper-step>

        </v-stepper-header>
        <inner-loading-spinner :loading="loading"></inner-loading-spinner>
        <v-stepper-items>
            <v-layout wrap justify-center>
                <v-flex xs12 sm10 md9 lg8 xl6>

                    <v-stepper-content step="1">

                        <!--Create user-->
                        <account-sign-up-form
                                ref="basicSignUp"
                                :auto-login="true"
                                :facebook-login="false"
                                v-on:before-send="loading=true"
                                v-on:error="onSignUpFail"
                                v-on:success="onSignUpSuccess"
                                v-on:validation-change="onSignUpValidationChange"
                                submit-label="Siguiente"
                                :disabled="loading"
                        ></account-sign-up-form>

                        <v-flex sm12 text-right class="actions-wrapper">
                            <v-btn v-if="goBack" flat @click="goBack">Atrás</v-btn>
                        </v-flex>

                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <v-layout wrap>
                            <v-flex xs12 text-center>
                                <account-activation-listener
                                    ref="activationListener"
                                    :counter="resendCounter"
                                    :onCodeRequestFail="onCodeRequestFail"
                                    :onAccountActivated="onAccountActivated"
                                    :onActivationCodeSent="onActivationCodeSent"
                                    :hideSubmitButton="true"
                                ></account-activation-listener>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>

                    <v-stepper-content step="3">

                       <v-flex xs12 text-center>
                           <h2  class="font-weight-light mt-4">
                               ¡Felicitaciones!
                           </h2>
                           <h3 class="font-weight-regular">Tu cuenta ha sido activada</h3>

                           <v-btn depressed :to="{name: 'panel.onboarding'}" color="primary" dark class="mt-4">
                               Ir a mi cuenta
                           </v-btn>
                       </v-flex>

                    </v-stepper-content>

                </v-flex>
            </v-layout>
        </v-stepper-items>
    </v-stepper>

</template>

<script>

    import {mapState, mapMutations} from 'vuex'

    import InnerLoadingSpinner from '@/components/common/InnerLoadingSpinner'

    import AccountActivationListener from '@/components/account/AccountActivationListener'
    import AccountSignUpForm from '@/components/account/AccountSignUpForm'

    export default{
        props: ['color', 'goBack'],
        components: {
            InnerLoadingSpinner,
            AccountActivationListener,
            AccountSignUpForm
        },
        mounted(){

        },
        watch: {
            step(val){
              const vm = this
              if(val === 2){
                vm.resetResendCounter()
              }
            },
            currentUser(user){
                var vm = this
                if(user){
                    vm.$refs.activationListener.startListening(user.id)
                }else{
                    this.step = 1
                }
            }
        },
        data(){
            return {
                showResendCode: false,
                loading: false,

                step: 1,
                validStep1: false,
                validStep2: false,

                insuranceCompany: null,
                specialty: null,

                resendInterval: null,
                resendCounter: 59
            }
        },
        computed: { ...mapState(['currentUser'])},
        methods: {

            ...mapMutations(['showSnackBar']),

            resetResendCounter(){

              const vm = this

              vm.resendCounter = 59
              vm.resendInterval = setInterval(function(){
                if(vm.resendCounter === 0){
                  return clearInterval(vm.resendInterval)
                }
                vm.resendCounter--
              }, 1000)

            },

            onSignUpValidationChange(isValid){
                this.validStep1 = isValid
            },

            onSignUpSuccess(user){
                var vm = this
                vm.loading = false
                vm.showSnackBar('Cuenta creada!')
                vm.step = user.active ? 3 : 2
            },

            onSignUpFail(error){
                var vm = this
                vm.loading = false

                vm.showSnackBar(error.message)
            },

            onActivationCodeSent(){
                var vm = this
                vm.showSnackBar('Nuevo link enviado')
                vm.resetResendCounter()
            },

            onAccountActivated(){
                var vm = this
                vm.showSnackBar('Cuenta Activada!')
                vm.step = 3
            },

            onCodeRequestFail(err){
                var vm = this
                vm.showSnackBar('Ocurrió un error solicitando un nuevo código')
            },

            goTo(step = 1){
                this.step = step
            }
        }
    }
</script>

<style scoped>
    .step-content-wrapper {
        height: 360px
    }

    .v-stepper {
        box-shadow: none;
    }

    .actions-wrapper {
        margin: 25px 0 0 0;
    }
</style>
